/**
 * DISTRIBUTOR-ORDERS MODULE
 * Self-contained. Import only from /shared or within this module.
 *
 * sizeGroups :: the bottle-size bands the Summary / Forecast-Comparison
 * rollups subtotal by.
 *
 * These used to be a fixed pair of literals, which quietly assumed every
 * tenant sold the same two formats — anyone else got two permanently empty
 * subtotal rows. The bands are now derived from the account's own
 * `product_sizes` (System Settings → Product SKUs), in the order the account
 * put them in, with a final "All Cases" band that matches everything.
 *
 * `sales_goals.bottle_size` stores the size name, so goals keyed by whatever
 * sizes a tenant actually has work with no schema change.
 */

export const ALL_CASES_ID = "all_cases";

/**
 * @param {string[]} sizes  size names in the account's own order
 * @returns {{id:string,label:string,subtotalLabel:string,sizeMatch:string|null}[]}
 */
export function buildSizeGroups(sizes = []) {
  const seen = new Set();
  const groups = [];
  for (const raw of sizes) {
    const name = String(raw ?? "").trim();
    if (!name || seen.has(name)) continue;
    seen.add(name);
    groups.push({
      id: name,
      label: name,
      subtotalLabel: `Total ${name}`,
      sizeMatch: name,
    });
  }
  groups.push({
    id: ALL_CASES_ID,
    label: "All",
    subtotalLabel: "Total (All Cases)",
    sizeMatch: null,
  });
  return groups;
}

/** Just the real sizes — everything except the All Cases catch-all. */
export function sizeIdsOf(groups = []) {
  return groups.filter((g) => g.sizeMatch !== null).map((g) => g.id);
}

/** The size segment of a "Flavor / Size / Pack" SKU name. */
export function skuSize(skuName) {
  return (skuName || "").split(" / ")[1] || "";
}
